import(/* webpackMode: "eager" */ "C:\\Dev\\gogedit_react_nextjs_ts_website\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Dev\\gogedit_react_nextjs_ts_website\\src\\app\\home-page\\components\\NavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Dev\\gogedit_react_nextjs_ts_website\\src\\components\\ui\\AppLogo.tsx");
